import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

const work = [
  { number: '01', title: 'Keep the profile active', description: 'Publish ongoing Google Business Profile updates so the business stays current for nearby searchers.', color: '#3fc0fa' },
  { number: '02', title: 'Show up across channels', description: 'Repurpose posts for Facebook and Instagram,and distribute short videos across social,YouTube and Google.', color: '#f8b86a' },
  { number: '03', title: 'Make progress visible', description: 'Generate FAQs,send reports and use ranking audits to track what is improving and where work remains.', color: '#c8b6ff' }
];

export default function WorkAndNextStep() {
  return (
    <>
      <section className="bg-[#101c2d] py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#c8b6ff]">Behind the numbers</p>
          <h2 className="mt-4 max-w-3xl text-3xl font-black tracking-tight text-white sm:text-5xl">Not a one-time update. Ongoing work.</h2>
          <p className="mt-5 max-w-2xl leading-relaxed text-slate-300">The activity log documents recurring posts across Google,Facebook and Instagram,along with videos,FAQs and reports. Here is what that managed approach looks like.</p>
          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {work.map((item) => (
              <div key={item.number} className="rounded-2xl border border-white/10 bg-[#19283d] p-7" style={{ borderTop: `3px solid ${item.color}` }}>
                <span className="text-sm font-black" style={{ color: item.color }}>{item.number}</span>
                <h3 className="mt-8 text-xl font-bold text-white">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[#0b1423] px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 rounded-[2rem] bg-[#f8b86a] p-8 text-[#0b1423] sm:p-12 lg:flex-row lg:items-center lg:p-16">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em]">Your business could be next</p>
            <h2 className="mt-4 text-3xl font-black leading-tight sm:text-5xl">Let’s put your local presence to work.</h2>
            <p className="mt-4 leading-relaxed">Explore our managed Local Momentum plan and see what we can take off your plate.</p>
          </div>
          <Link to="/pricing" className="inline-flex shrink-0 items-center gap-3 rounded-full bg-[#0b1423] px-7 py-4 font-bold text-white transition-colors hover:bg-[#22344d]">
            Explore the plan <SafeIcon icon={FiArrowUpRight} />
          </Link>
        </div>
      </section>
    </>
  );
}